function getSpeciesTitle(species: string | number, formatMessage: Function) {
  return formatMessage({ id: `plantingCycles.speciesPlural.${species}` });
}

export default getSpeciesTitle;

